import {
  AddPropertyResponse,
  // PropertyCommonResponse,
  PropertyError,
  Property,
  PropertyResponse,
  DeletedProperty,
} from '@core/interface/property';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PropertyActions = createActionGroup({
  source: 'Property',
  events: {
    'Load Properties': props<PagePayload>(),
    'Load Properties Success': props<PropertyResponse>(),
    'Load Properties Failure': props<PropertyError>(),
    'Add Edit Property': props<Property>(),
    'Add Property Success': props<AddPropertyResponse>(),
    'Update Property Success': props<AddPropertyResponse>(),
    'Add Property Failure': props<PropertyError>(),
    'Update Property Failure': props<PropertyError>(),
    'Delete Property': props<{ id: number }>(),
    'Delete Property Success': props<DeletedProperty>(),
    'Delete Property Failure': props<PropertyError>(),
    'Reset Data': emptyProps(),
    'Reset Properties': emptyProps(),
  },
});
